import classNames from 'classnames';

const ToggleSwitch = ({ name, label, checked, onChange = () => {}, readonly, inverted = false, className = '' }) => {
    return (
        <span className={classNames("toggle-switch-rounded-container", className)}>
            <label className={classNames('toggle-switch-rounded', { inverted })}>
                <input
                    type="checkbox"
                    checked={checked}
                    name={name}
                    onChange={(e) => !readonly && onChange(e)}
                    disabled={readonly}
                />
                <span className="slider round"></span>
            </label>
            {label}
        </span>
    );
};

export default ToggleSwitch;
